<template>
  <v-container fluid :class="['mt-n3', $vuetify.breakpoint.smAndDown ? 'px-4' : 'ml-n2']">
    <v-row>
      <v-col cols="12" md="8" lg="7" xl="9" order="2" order-md="1">
        <h1 v-if="homeContent && homeContent.greeting" class="mb-4 display-1 d-none d-md-block">{{ homeContent.greeting }}</h1>
        <p v-if="homeContent && homeContent.intro" class="home-intro mt-2">{{ homeContent.intro }}</p>
        <home-step-card
          v-for="(step, i) in homeContent && homeContent.steps"
          :key="i"
          :step="step"
          class="mb-4"
        />
      </v-col>
      <v-col cols="12" md="4" lg="5" xl="3" order="1" order-md="2" class="d-flex flex-column">
        <h1 v-if="homeContent && homeContent.greeting" class="mb-4 display-1 d-md-none">{{ homeContent.greeting }}</h1>
        <div
          v-for="(item, i) in homeContent && homeContent.news"
          :key="i"
          class="news-item pa-3 mb-3"
          :class="i % 2 === 0 ? 'news-item--primary' : 'news-item--surface'"
          v-html="item.html"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HomeStepCard from '@/components/HomeStepCard.vue';

export default {
  name: 'LoggedInStart',

  components: { HomeStepCard },

  data: () => ({
    contentLocale: ''
  }),

  computed: {
    ...mapGetters('app', ['homeContent', 'locale']),
    ...mapActions('app', ['showRightsholderForm'])
  },

  mounted() {
    if (!this.homeContent || this.locale!==this.contentLocale) {
      this.$store.dispatch('app/loadHomeContent', this.locale)
      this.contentLocale = this.locale
    }
    window.showIfpiDialog = this.exposedFunction.bind(this)
  },

  watch: {
    locale() {
      this.$store.dispatch('app/loadHomeContent', this.locale)
      this.contentLocale = this.locale
    },
  },

  methods: {
    async exposedFunction(val) {
      await this.$store.dispatch('app/showRightsholderForm', val.form)
      return false;
    }
  }
}
</script>

<style scoped>
  .home-content p {
    word-wrap: break-word;
  }
  .news-item {
    border-radius: 8px;
    overflow: hidden;
  }
  .news-item ::v-deep img {
    max-width: 100%;
    height: auto;
  }
  .news-item ::v-deep * {
    word-break: break-word;
    overflow-wrap: break-word;
  }
  .news-item ::v-deep table {
    max-width: 100%;
    table-layout: fixed;
  }
  .news-item--primary {
    background-color: var(--color-inverse-primary);
  }
  .news-item--surface {
    background-color: var(--color-surface-bright);
  }
  .home-intro {
    font-family: 'DM Sans', sans-serif;
    font-weight: 800;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0px;
  }
</style>